module.exports = __webpack_public_path__ + "img/8.f14a719d.jpg";